(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var openFacts = event.target.closest('[data-sn-facts-open]');
    if (openFacts) { var dialog = openFacts.closest('.sn-product').querySelector('[data-sn-facts-dialog]'); if (dialog) dialog.showModal(); return; }
    var closeFacts = event.target.closest('[data-sn-facts-close]');
    if (closeFacts) { var dialog = closeFacts.closest('[data-sn-facts-dialog]'); if (dialog) dialog.close(); }
  });
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-sn-package]')) return;
    var section = event.target.closest('[data-sn-product-section]');
    var form = event.target.closest('form');
    var option = event.target.selectedOptions[0];
    if (!section || !form || !option) return;
    var variantInput = form.querySelector('[data-sn-variant]');
    var price = section.querySelector('[data-sn-price]');
    var compare = section.querySelector('[data-sn-compare]');
    var addButton = form.querySelector('[data-sn-add]');
    var label = form.querySelector('[data-sn-add-label]');
    if (variantInput) variantInput.value = option.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    if (addButton && label) {
      var available = option.dataset.available === 'true';
      addButton.disabled = !available;
      label.textContent = available ? label.dataset.defaultText : label.dataset.soldOutText;
    }
  });
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-sn-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-sn-gallery]');
    var image = gallery && gallery.querySelector('.sn-product__image');
    var imageButton = gallery && gallery.querySelector('[data-sn-open-lightbox]');
    var video = gallery && gallery.querySelector('[data-sn-gallery-video]');
    if (!image || !imageButton) return;
    if (thumb.dataset.videoSrc && video) {
      imageButton.hidden = true;
      video.hidden = false;
      var videoSource = video.querySelector('source');
      if (videoSource && videoSource.src !== thumb.dataset.videoSrc) { videoSource.src = thumb.dataset.videoSrc; video.load(); }
    } else {
      imageButton.hidden = false;
      if (video) { video.pause(); video.hidden = true; }
      image.src = thumb.dataset.fullSrc;
      image.removeAttribute('srcset');
      image.alt = thumb.dataset.fullAlt || '';
    }
    gallery.querySelectorAll('[data-sn-thumb]').forEach(function(button) {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });
    thumb.classList.add('is-selected');
    thumb.setAttribute('aria-pressed', 'true');
  });
  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-sn-open-lightbox]');
    if (!opener) return;
    var gallery = opener.closest('[data-sn-gallery]');
    var dialog = gallery && gallery.querySelector('[data-sn-lightbox]');
    var thumbs = gallery && Array.from(gallery.querySelectorAll('[data-sn-thumb]'));
    if (!dialog || !thumbs || !thumbs.length) return;
    var index = Math.max(0, thumbs.findIndex(function(button) { return button.classList.contains('is-selected'); }));
    dialog.dataset.index = index;
    dialog.querySelector('[data-sn-lightbox-image]').src = thumbs[index].dataset.fullSrc;
    dialog.querySelector('[data-sn-lightbox-image]').alt = thumbs[index].dataset.fullAlt || '';
    dialog.querySelector('[data-sn-lightbox-count]').textContent = (index + 1) + ' / ' + thumbs.length;
    if (!dialog.open) dialog.showModal();
  });
  document.addEventListener('click', function(event) {
    var close = event.target.closest('[data-sn-lightbox-close]');
    if (close) { var closeDialog = close.closest('[data-sn-lightbox]'); if (closeDialog) closeDialog.close(); return; }
    var arrow = event.target.closest('[data-sn-lightbox-prev], [data-sn-lightbox-next]');
    if (!arrow) return;
    var dialog = arrow.closest('[data-sn-lightbox]');
    var gallery = dialog && dialog.closest('[data-sn-gallery]');
    var thumbs = gallery && Array.from(gallery.querySelectorAll('[data-sn-thumb]'));
    if (!dialog || !thumbs || !thumbs.length) return;
    var current = Number(dialog.dataset.index || 0);
    var direction = arrow.matches('[data-sn-lightbox-next]') ? 1 : -1;
    var index = (current + direction + thumbs.length) % thumbs.length;
    dialog.dataset.index = index;
    thumbs[index].click();
    dialog.querySelector('[data-sn-lightbox-image]').src = thumbs[index].dataset.fullSrc;
    dialog.querySelector('[data-sn-lightbox-image]').alt = thumbs[index].dataset.fullAlt || '';
    dialog.querySelector('[data-sn-lightbox-count]').textContent = (index + 1) + ' / ' + thumbs.length;
  });
  document.addEventListener('keydown', function(event) {
    var dialog = document.querySelector('[data-sn-lightbox][open]');
    if (!dialog) return;
    if (event.key === 'ArrowRight') dialog.querySelector('[data-sn-lightbox-next]').click();
    if (event.key === 'ArrowLeft') dialog.querySelector('[data-sn-lightbox-prev]').click();
  });
  document.addEventListener('click', function(event) {
    var choice = event.target.closest('[data-sn-form-choice], [data-sn-potency-choice]');
    if (!choice) return;
    var section = choice.closest('[data-sn-product-section]');
    if (!section) return;
    var group = choice.closest('.sn-choice-group');
    group.querySelectorAll('.sn-choice').forEach(function(button) {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });
    choice.classList.add('is-selected');
    choice.setAttribute('aria-pressed', 'true');
    var packages = section.querySelector('[data-sn-package]');
    if (!packages) return;
    var selectedForm = section.querySelector('[data-sn-form-choice].is-selected');
    var selectedPotency = section.querySelector('[data-sn-potency-choice].is-selected');
    if (choice.matches('[data-sn-form-choice]') && selectedForm && selectedPotency) {
      var potencyMatchesForm = Array.from(packages.options).some(function(option) {
        return option.dataset.form === selectedForm.dataset.snFormChoice && option.dataset.potency === selectedPotency.dataset.snPotencyChoice;
      });
      if (!potencyMatchesForm) {
        var firstForForm = Array.from(packages.options).find(function(option) { return option.dataset.form === selectedForm.dataset.snFormChoice; });
        if (firstForForm) {
          var replacement = section.querySelector('[data-sn-potency-choice="' + CSS.escape(firstForForm.dataset.potency) + '"]');
          if (replacement) {
            selectedPotency.classList.remove('is-selected');
            selectedPotency.setAttribute('aria-pressed', 'false');
            replacement.classList.add('is-selected');
            replacement.setAttribute('aria-pressed', 'true');
            selectedPotency = replacement;
          }
        }
      }
    }
    var matching = [];
    Array.from(packages.options).forEach(function(option) {
      var visible = (!selectedForm || option.dataset.form === selectedForm.dataset.snFormChoice) &&
        (!selectedPotency || option.dataset.potency === selectedPotency.dataset.snPotencyChoice);
      option.hidden = !visible;
      if (visible) matching.push(option);
    });
    if (matching.length) {
      packages.value = matching[0].value;
      packages.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!window.__snProductTabsBound) {
    window.__snProductTabsBound = true;
    document.addEventListener('change', function(event) {
      var input = event.target.closest('.sn-product-description__tab-input');
      if (!input) return;
      var section = input.closest('[data-sn-product-tabs]');
      if (!section) return;
      section.querySelectorAll('.sn-product-description__panel').forEach(function(panel) { panel.hidden = true; });
      var panel = section.querySelector('#' + CSS.escape(input.id.replace('sn-tab-', 'sn-panel-')));
      if (panel) panel.hidden = false;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
